import { useEffect, useState } from 'react'

/**
 * Сообщение о выполненном действии. Живёт 2,6 секунды — как в прототипе, —
 * ничего не перехватывает и читается вслух: роль `status` не прерывает работу.
 */
export function Toast({ message, onHide }: { message: string; onHide: () => void }) {
  const [shown, setShown] = useState(message)

  useEffect(() => {
    setShown(message)
    const timer = setTimeout(onHide, 2600)
    return () => {
      clearTimeout(timer)
    }
  }, [message, onHide])

  return (
    <div className="toast" role="status">
      {shown}
    </div>
  )
}
